module.exports = __webpack_public_path__ + "static/media/bgImage.907cdf4c.jpg";